import { render, staticRenderFns } from "./B-1-1-1_HomePage_BrandVisual.vue?vue&type=template&id=39aa2ead&"
import script from "./B-1-1-1_HomePage_BrandVisual.vue?vue&type=script&lang=js&"
export * from "./B-1-1-1_HomePage_BrandVisual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports